import React, { forwardRef } from 'react'
import { clsx } from 'clsx'

interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
  size?: 'sm' | 'md' | 'lg'
  error?: string
}

export const Input = forwardRef<HTMLInputElement, InputProps>(({
  size = 'md',
  error,
  className,
  ...props
}, ref) => {
  const sizeClasses = {
    sm: 'px-2 py-1 text-sm',
    md: 'px-3 py-2 text-sm',
    lg: 'px-4 py-3 text-base'
  }
  
  return (
    <div className="w-full">
      <input
        ref={ref}
        className={clsx(
          'block w-full rounded-md border-gray-300 shadow-sm transition-colors',
          'focus:border-blue-500 focus:ring-blue-500',
          'dark:bg-gray-700 dark:border-gray-600 dark:text-white',
          'disabled:bg-gray-100 disabled:text-gray-500 dark:disabled:bg-gray-800',
          error && 'border-red-300 focus:border-red-500 focus:ring-red-500',
          sizeClasses[size],
          className
        )}
        {...props}
      />
      {error && (
        <p className="mt-1 text-sm text-red-600 dark:text-red-400">{error}</p>
      )}
    </div>
  )
})

Input.displayName = 'Input'